import React,{useState, useEffect} from 'react';

const Livecamera = (props) => {

const [imageUrl, setimageUrl] = useState('http://admin:ismart123456@192.168.1.4/cgi-bin/snapshot.cgi?loginuse=admin&loginpas=ismart123456');




return (  
<>
<div className ="container-fluid" >
<div className="m-1 d-flex justify-content-center">
      <span className="badge rounded-pill bg-success" style={{ fontSize: "16px" }}>
       Live view
      </span>
      </div>
<div className ="row" >
<div className="col-sm-6 col-md-6 col-lg-6">
            <div className="mt-1">

            <div className="row no-gutters align-items-center justify-content-left">
    <div className="col-auto text-center mb-2 p-1 text-center">
      <iframe
        src={imageUrl}
          width="640"
     
      ></iframe>
    </div>
    </div>
            </div>
</div>

</div>
</div>




</>

    );
}
 
export default Livecamera